import {ISelect} from '../../../../interface/ISelect';
import {sumRoundedToTwoDecimals} from '../../../../utils/formatIndian';

export const CarbonOffsetKey = {
  PROJECTS: 'projects',
  PROJECT_NAME: 'projectName',
  PROJECT_TYPE: 'projectType',
  STAGE_TYPE: 'stageType',
  EMISSIONS_OFFSET: 'emissionsOffset',
  DESCRIPTION: 'description',
  UPDATED_AT: 'updatedAt'
};

export const CarbonOffsetLabel = {
  PROJECT_NAME: 'Project Name',
  PROJECT_TYPE: 'Project Type',
  STAGE_TYPE: 'Stage Type',
  EMISSIONS_OFFSET: 'Emissions offset',
  EMISSIONS_OFFSET_COLUMN: 'Emissions Offset',
  DESCRIPTION: 'Description',
  FISCAL_YEAR: 'Fiscal Year',
  LAST_UPDATED: 'Last Updated',
  TOTAL_EMISSIONS_OFFSET: 'Total emissions offset'
};

export const CarbonOffsetProjectType = {
  NATURE_BASE: 'natureBase',
  TECHNOLOGY_BASE: 'technologyBase'
};

export const carbonOffsetProjectTypes: ISelect[] = [
  {value: CarbonOffsetProjectType.NATURE_BASE, label: 'Nature Base'},
  {value: CarbonOffsetProjectType.TECHNOLOGY_BASE, label: 'Technology Base'}
];

export const carbonOffsetStageTypes: ISelect[] = [
  {value: 'individualBuying', label: 'Individual Buying'},
  {value: 'forwardPurchaseBuying', label: 'Forward Purchase Buying'}
];

export const carbonOffsetSteps = ['Choose Year', 'Project Details'];

export const EMISSIONS_OFFSET_VALIDATION_MESSAGE =
  'Enter a positive number with up to 2 decimal places';

// Positive numbers only, with at most 2 decimal places. Rejects 0, negatives,
// and values such as 1.234.
export const isValidEmissionsOffset = (value: unknown): boolean => {
  if (value === null || value === undefined || value === '') {
    return false;
  }

  const text = String(value).replace(/,/g, '').trim();

  if (!/^\d+(\.\d{1,2})?$/.test(text)) {
    return false;
  }

  return Number(text) > 0;
};

export const sumEmissionsOffset = (projects: any[] | undefined): number => {
  return sumRoundedToTwoDecimals(
    (projects ?? []).map(
      (project: any) => project?.[CarbonOffsetKey.EMISSIONS_OFFSET]
    )
  );
};
